import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-MinusB",
  "use": "icon-MinusB-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-MinusB\">\n<path d=\"M14.5 6.90039C14.7761 6.90039 15 7.12425 15 7.40039V8.59961C15 8.87575 14.7761 9.09961 14.5 9.09961H1.5C1.22386 9.09961 1 8.87575 1 8.59961V7.40039C1 7.12425 1.22386 6.90039 1.5 6.90039H14.5Z\" fill=\"#242333\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol